<p style="font-size:1.125rem;">
    <span [class]="prefixClass">{{envPrefix}}</span>
    <span class="px-2 font-semibold text-xl text-primary-600 dark:text-primary-600 uppercase">{{title}}</span>
    <span [class]="prefixClass">{{envPrefix}}</span>
</p>
